import { cleanDoubleSlashes } from '@nx/populate-url'
import { seoName } from '@nx/seo-name'

import { domainBuilder } from '../domainBuilder/domainBuilder'

export function buildDepartmentPath(
  departmentId: string,
  departmentName: string,
  domain?: string
) {
  const seoFriendlyName = seoName(departmentName)
  let path = `/department/${departmentId}/${seoFriendlyName}/`

  if (domain) {
    path = domainBuilder(domain, path)
  }

  return cleanDoubleSlashes(path)
}
